module.exports = __webpack_public_path__ + "img/hero-company.a82878a4.jpg";